// Patients page interactive components

const { useState: pUS, useEffect: pUE, useRef: pUR } = React;

// ---- Scheduler ----
const OPERATORIES = ['Op 1', 'Op 2', 'Op 3', 'Op 4', 'Op 5'];
const HOURS = ['8:00','9:00','10:00','11:00','12:00','1:00','2:00','3:00','4:00'];
const SLOT_H = 48; // px

// Time helpers - 8:00 = 0, each hour = 60min, each slot height = 48
function minutesFromStart(h, m) { return (h - 8) * 60 + m; }

const APPTS = [
  { col: 0, start: [8, 30], dur: 60, status: 'done', initials: 'MT', name: 'Marcus Tan', proc: 'Limited Exam · #19' },
  { col: 0, start: [10, 0], dur: 90, status: 'in-chair', initials: 'YO', name: 'Yuki Ortega', proc: 'Crown seat · #14' },
  { col: 0, start: [13, 0], dur: 60, status: 'scheduled', initials: 'JM', name: 'J. Mendez', proc: 'Post-op check' },
  { col: 0, start: [14, 30], dur: 45, status: 'scheduled', initials: 'AL', name: 'A. Lin', proc: 'Hygiene recall' },

  { col: 1, start: [9, 0], dur: 60, status: 'done', initials: 'DR', name: 'Diana Reyes', proc: 'Crown prep · #30' },
  { col: 1, start: [11, 0], dur: 30, status: 'canceled', initials: 'PK', name: 'P. Kim', proc: 'Recall · cancelled' },
  { col: 1, start: [13, 30], dur: 60, status: 'scheduled', initials: 'BH', name: 'Bea Hsu', proc: 'New patient' },
  { col: 1, start: [15, 0], dur: 60, status: 'scheduled', initials: 'NK', name: 'N. Kapoor', proc: 'Filling · #5 MO' },

  { col: 2, start: [8, 0], dur: 60, status: 'done', initials: 'EJ', name: 'Eli Jaffe', proc: 'Recall · hygiene' },
  { col: 2, start: [9, 30], dur: 120, status: 'in-chair', initials: 'HV', name: 'Hannah Vo', proc: 'SRP UR · #14-#15', live: true },
  { col: 2, start: [13, 0], dur: 60, status: 'checked-in', initials: 'RB', name: 'Rosa Briggs', proc: 'Recall · perio maint' },
  { col: 2, start: [14, 30], dur: 60, status: 'scheduled', initials: 'TG', name: 'T. Gerber', proc: 'Post-op SRP' },

  { col: 3, start: [9, 0], dur: 30, status: 'done', initials: 'SP', name: 'Sasha Park', proc: 'Bitewing series' },
  { col: 3, start: [10, 0], dur: 60, status: 'in-chair', initials: 'CR', name: 'Carla Romero', proc: 'D2740 · #19' },
  { col: 3, start: [11, 30], dur: 30, status: 'scheduled', initials: 'OK', name: 'O. Kapadia', proc: 'Limited exam' },
  { col: 3, start: [13, 0], dur: 90, status: 'scheduled', initials: 'IF', name: 'Isabel Fox', proc: 'Ortho check' },

  { col: 4, start: [8, 30], dur: 60, status: 'done', initials: 'WB', name: 'W. Brand', proc: 'Hygiene + exam' },
  { col: 4, start: [11, 0], dur: 60, status: 'checked-in', initials: 'JK', name: 'Jordan Kim', proc: 'D4910 maint' },
  { col: 4, start: [14, 0], dur: 60, status: 'scheduled', initials: 'EM', name: 'E. Morales', proc: 'Crown try-in' },
];

const STATUS_LABEL = {
  'scheduled': 'Scheduled',
  'checked-in': 'Checked in · waiting',
  'in-chair': 'In chair',
  'done': 'Complete',
  'canceled': 'Canceled',
};

function Scheduler() {
  const [selected, setSelected] = pUS(null); // appt index
  const containerRef = pUR();

  const handleClick = (i, e) => {
    setSelected(i);
  };

  return (
    <div className="sched-shell">
      <div className="sched-header">
        <div className="sched-date">
          <button className="sched-date-arrow">‹</button>
          <div>
            <div className="sched-day">Tuesday · May 18, 2026</div>
            <div className="sched-sub">5 operatories · 19 appointments</div>
          </div>
          <button className="sched-date-arrow">›</button>
        </div>
        <div style={{display:'flex', gap:12, alignItems:'center'}}>
          <div className="sched-views">
            <button>Day</button>
            <button className="active">Operatory</button>
            <button>Provider</button>
          </div>
          <a className="btn btn-sm btn-primary" href="lab.html">+ Visit</a>
        </div>
      </div>

      <div className="sched-grid" ref={containerRef}>
        {/* Time column */}
        <div className="sched-time-col">
          <div className="sched-col-h" style={{textAlign:'right'}}>&nbsp;</div>
          {HOURS.map((h, i) => (
            <div key={h} className="sched-time-cell">{h}</div>
          ))}
        </div>
        {/* Operatory columns */}
        {OPERATORIES.map((op, ci) => (
          <div key={op} className="sched-col">
            <div className="sched-col-h">
              {op}
              <div className="sched-col-h-sub">{ci === 2 ? 'Dr. Patel' : ci === 3 ? 'Dr. Cho' : ci === 0 ? 'Dr. Park' : 'Hygiene'}</div>
            </div>
            {APPTS.filter(a => a.col === ci).map((a, ai) => {
              const top = 44 + minutesFromStart(a.start[0], a.start[1]) * (SLOT_H/60);
              const h = a.dur * (SLOT_H/60) - 4;
              const idx = APPTS.indexOf(a);
              return (
                <div key={ai}
                     className={"sched-appt " + a.status + (a.live ? " live" : "")}
                     style={{ top: top + 'px', height: h + 'px' }}
                     onClick={(e) => handleClick(idx, e)}>
                  <div className="sched-appt-time">{a.start[0] > 12 ? a.start[0]-12 : a.start[0]}:{String(a.start[1]).padStart(2,'0')}{a.start[0]>=12?'p':'a'} · {a.dur}m</div>
                  <div className="sched-appt-name">{a.name}</div>
                  <div className="sched-appt-proc">{a.proc}</div>
                </div>
              );
            })}
          </div>
        ))}

        {/* Popover */}
        {selected != null && (() => {
          const a = APPTS[selected];
          const colWidthPct = `calc(70px + (100% - 70px) * ${a.col + 1} / 5)`;
          return (
            <div className="sched-popover"
                 style={{
                   left: `calc(70px + (100% - 70px) * ${a.col} / 5 + 8px)`,
                   top: (44 + minutesFromStart(a.start[0], a.start[1]) * (SLOT_H/60) + 8) + 'px',
                 }}>
              <div className="sched-popover-head">
                <div className="patient-avatar" style={{width:40, height:40, fontSize:13}}>{a.initials}</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:15, fontWeight:600}}>{a.name}</div>
                  <div style={{fontSize:12, color:'var(--text-soft)'}}>{STATUS_LABEL[a.status]}</div>
                </div>
                <button onClick={() => setSelected(null)} style={{color:'var(--text-soft)', fontSize:18, width:24, height:24}}>×</button>
              </div>
              <div className="sched-popover-body">
                <div className="sched-popover-row">
                  <span>Procedure</span>
                  <span style={{fontWeight:500}}>{a.proc}</span>
                </div>
                <div className="sched-popover-row">
                  <span>Time</span>
                  <span style={{fontFamily:'var(--font-mono)'}}>{a.start[0]>12?a.start[0]-12:a.start[0]}:{String(a.start[1]).padStart(2,'0')} · {a.dur}m</span>
                </div>
                <div className="sched-popover-row">
                  <span>Provider</span>
                  <span>{a.col === 2 ? 'Dr. Patel' : a.col === 3 ? 'Dr. Cho' : a.col === 0 ? 'Dr. Park' : 'Hygiene team'}</span>
                </div>
                <div className="sched-popover-row">
                  <span>Talking points</span>
                  <span style={{fontSize:12.5, color:'var(--text-muted)', lineHeight:1.5}}>
                    {a.col === 2 && a.live ? 'Latex allergy - nitrile only. Prefers nitrous for SRP.' :
                     a.col === 3 ? 'Bruxer; verify nightguard fit.' :
                     a.col === 0 ? 'New patient. Confirm insurance + ID at check-in.' :
                     a.col === 1 ? 'Anxious patient. Offer headphones; slower pace.' :
                     'Caries risk: high. Discuss fluoride varnish.'}
                  </span>
                </div>
              </div>
              <div className="sched-popover-actions">
                {a.status === 'in-chair' || a.live ? (
                  <a className="btn btn-sm btn-primary" href="lab.html" style={{flex:1, justifyContent:'center'}}>● Open Lab</a>
                ) : (
                  <a className="btn btn-sm btn-primary" href="lab.html" style={{flex:1, justifyContent:'center'}}>Start visit</a>
                )}
                <button className="btn btn-sm btn-ghost">Reschedule</button>
              </div>
            </div>
          );
        })()}
      </div>

      <div className="sched-legend">
        <div className="sched-legend-item"><span className="sched-legend-dot" style={{background:'#E0F2FE'}}></span>Scheduled</div>
        <div className="sched-legend-item"><span className="sched-legend-dot" style={{background:'#FEF3C7'}}></span>Checked in</div>
        <div className="sched-legend-item"><span className="sched-legend-dot" style={{background:'var(--teal-wash)'}}></span>In chair</div>
        <div className="sched-legend-item"><span className="sched-legend-dot" style={{background:'#DCFCE7'}}></span>Complete</div>
        <div className="sched-legend-item"><span className="sched-legend-dot" style={{background:'var(--surface-muted)'}}></span>Canceled</div>
      </div>
    </div>
  );
}

// ---- Patient page ----
const PATIENTS = [
  { id:'hv', name:'Hannah Vo', age:34, sub:'Active · perio · UR', initials:'HV' },
  { id:'mt', name:'Marcus Tan', age:42, sub:'Recall due', initials:'MT' },
  { id:'yo', name:'Yuki Ortega', age:58, sub:'Crown seat today', initials:'YO' },
  { id:'jk', name:'Jordan Kim', age:29, sub:'Perio maintenance', initials:'JK' },
  { id:'cr', name:'Carla Romero', age:46, sub:'Active · #19 D2740', initials:'CR' },
  { id:'eq', name:'Eli Quartz', age:65, sub:'Implant consult', initials:'EQ' },
  { id:'nm', name:'Naomi Marsh', age:31, sub:'New patient', initials:'NM' },
  { id:'ts', name:'Theo Suarez', age:11, sub:'Pedo · sealant', initials:'TS' },
];

function PatientPage() {
  const [active, setActive] = pUS('hv');
  const [q, setQ] = pUS('');
  const list = PATIENTS.filter(p => !q || p.name.toLowerCase().includes(q.toLowerCase()));
  const p = PATIENTS.find(x => x.id === active) || PATIENTS[0];

  return (
    <div className="patient-shell">
      <aside className="patient-list">
        <div className="patient-list-search">
          <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Search patients…" />
        </div>
        {list.map(pt => (
          <div key={pt.id} className={"patient-row " + (pt.id === active ? "active" : "")} onClick={() => setActive(pt.id)}>
            <div className="patient-avatar" style={{background: avatarGrad(pt.id)}}>{pt.initials}</div>
            <div style={{flex:1, minWidth:0}}>
              <div className="patient-row-name">{pt.name}</div>
              <div className="patient-row-sub">{pt.sub}</div>
            </div>
          </div>
        ))}
      </aside>
      <div className="patient-detail">
        <div className="patient-head">
          <div className="patient-head-avatar" style={{background: avatarGrad(p.id)}}>{p.initials}</div>
          <div style={{flex:1}}>
            <div className="patient-name">{p.name}</div>
            <div className="patient-meta">{p.age} · F · Established · Provider: Dr. Patel</div>
          </div>
          <a className="btn btn-sm btn-primary" href="lab.html">Open Lab</a>
        </div>

        <div>
          <div style={{fontSize:11, color:'var(--text-soft)', letterSpacing:'0.06em', textTransform:'uppercase', fontWeight:600, marginBottom:10}}>Pinned</div>
          <div className="patient-pins">
            <div className="patient-pin warn">⚠ Latex allergy - nitrile gloves only.</div>
            <div className="patient-pin note">Prefers nitrous oxide for any SRP / extraction.</div>
            <div className="patient-pin info">Prefers afternoon appointments · works mornings.</div>
          </div>
        </div>

        <div className="patient-cols">
          <div>
            <div style={{fontSize:11, color:'var(--text-soft)', letterSpacing:'0.06em', textTransform:'uppercase', fontWeight:600, marginBottom:10}}>Last visit · May 18</div>
            <div style={{fontSize:13, lineHeight:1.6, padding:'14px 16px', background:'var(--surface-subtle)', borderRadius:10, border:'1px solid var(--border)'}}>
              <div><strong>Procedure:</strong> Periodontal SRP, UR quadrant</div>
              <div><strong>Findings:</strong> #14 DL 6mm BOP+, #15 M 8mm BOP+ mob 1</div>
              <div><strong>Codes:</strong> D4341, D9215</div>
              <div><strong>Recall:</strong> 4–6 weeks for re-eval</div>
            </div>
          </div>
          <div>
            <div style={{fontSize:11, color:'var(--text-soft)', letterSpacing:'0.06em', textTransform:'uppercase', fontWeight:600, marginBottom:10}}>Account</div>
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:10}}>
              <div style={{padding:14, background:'var(--surface-subtle)', borderRadius:10, border:'1px solid var(--border)'}}>
                <div style={{fontSize:11, color:'var(--text-soft)', textTransform:'uppercase', letterSpacing:'0.04em', fontWeight:600}}>Balance</div>
                <div style={{fontFamily:'var(--font-mono)', fontSize:18, fontWeight:600, marginTop:4}}>$148.00</div>
              </div>
              <div style={{padding:14, background:'var(--surface-subtle)', borderRadius:10, border:'1px solid var(--border)'}}>
                <div style={{fontSize:11, color:'var(--text-soft)', textTransform:'uppercase', letterSpacing:'0.04em', fontWeight:600}}>Insurance</div>
                <div style={{fontSize:13, marginTop:4}}>Aetna PPO</div>
                <div style={{fontSize:11, color:'var(--text-soft)'}}>Eligible · verified 5/15</div>
              </div>
              <div style={{padding:14, background:'var(--surface-subtle)', borderRadius:10, border:'1px solid var(--border)'}}>
                <div style={{fontSize:11, color:'var(--text-soft)', textTransform:'uppercase', letterSpacing:'0.04em', fontWeight:600}}>Recall</div>
                <div style={{fontSize:13, marginTop:4, color:'var(--warning)'}}>Re-eval · 6/15</div>
              </div>
              <div style={{padding:14, background:'var(--surface-subtle)', borderRadius:10, border:'1px solid var(--border)'}}>
                <div style={{fontSize:11, color:'var(--text-soft)', textTransform:'uppercase', letterSpacing:'0.04em', fontWeight:600}}>Last hygiene</div>
                <div style={{fontSize:13, marginTop:4}}>Nov 12, 2025</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function avatarGrad(id) {
  const c = id.charCodeAt(0) + id.charCodeAt(1);
  const colors = [
    'linear-gradient(135deg, #19ADC5, #0F7689)',
    'linear-gradient(135deg, #6B5BC5, #3B2F89)',
    'linear-gradient(135deg, #C5526B, #893545)',
    'linear-gradient(135deg, #C58A19, #8A5E0F)',
    'linear-gradient(135deg, #2A85C5, #14497A)',
  ];
  return colors[c % colors.length];
}

// ---- Analytics dashboard ----
function Dashboard() {
  // Build a simple line chart path
  const pts = (vals, w=300, h=80) => {
    const max = Math.max(...vals);
    const min = Math.min(...vals);
    const r = max - min || 1;
    return vals.map((v, i) => {
      const x = (i / (vals.length-1)) * w;
      const y = h - ((v - min) / r) * h;
      return (i === 0 ? 'M' : 'L') + x.toFixed(1) + ',' + y.toFixed(1);
    }).join(' ');
  };
  const production = [18200, 19400, 17800, 22100, 24300, 23800, 26500, 28200, 27400, 29800, 31200, 32900];
  const perioVisits = [12, 14, 15, 11, 18, 22, 24, 26, 25, 28, 31, 34];

  return (
    <div className="dash-grid">
      <div className="dash-card dash-card--feature">
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start'}}>
          <div>
            <div className="dash-label">Monthly production</div>
            <div className="dash-value">$32,900<span className="unit"> May 26</span></div>
            <div className="dash-delta up">↑ 14.2% vs trailing 3-mo avg</div>
          </div>
          <div style={{display:'flex', gap:8}}>
            <button className="btn btn-sm btn-ghost-dark">12 mo</button>
          </div>
        </div>
        <div className="dash-chart" style={{flex:1, marginTop:14}}>
          <svg viewBox="0 0 300 100" preserveAspectRatio="none" style={{width:'100%', height:'100%'}}>
            <defs>
              <linearGradient id="dashGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#19ADC5" stopOpacity="0.4"/>
                <stop offset="100%" stopColor="#19ADC5" stopOpacity="0"/>
              </linearGradient>
            </defs>
            <path d={pts(production, 300, 80) + ' L 300,100 L 0,100 Z'} fill="url(#dashGrad)" />
            <path d={pts(production, 300, 80)} fill="none" stroke="#22C0DA" strokeWidth="2" strokeLinecap="round"/>
            {production.map((v,i) => (
              <circle key={i} cx={(i/(production.length-1))*300} cy={80 - ((v-Math.min(...production))/(Math.max(...production)-Math.min(...production)))*80} r="2.5" fill="#22C0DA"/>
            ))}
          </svg>
        </div>
      </div>

      <div className="dash-card">
        <div className="dash-label">Perio visits / wk</div>
        <div className="dash-value">34<span className="unit"> avg</span></div>
        <div className="dash-delta up">↑ 6 vs last month</div>
        <svg viewBox="0 0 200 40" preserveAspectRatio="none" style={{height:40}}>
          <path d={pts(perioVisits, 200, 36)} fill="none" stroke="#6BD7E8" strokeWidth="2"/>
        </svg>
      </div>

      <div className="dash-card">
        <div className="dash-label">Hygiene throughput</div>
        <div className="dash-value">86<span className="unit">%</span></div>
        <div className="dash-delta up">on time, all rooms</div>
        <div style={{display:'flex', gap:3, marginTop:4}}>
          {Array.from({length:24}).map((_,i)=>(
            <span key={i} style={{flex:1, height:18, borderRadius:2, background: i<21?'#22C0DA':'rgba(255,255,255,0.1)'}}/>
          ))}
        </div>
      </div>

      <div className="dash-card">
        <div className="dash-label">Missed codes · this week</div>
        <div className="dash-value">$396</div>
        <div className="dash-delta up">caught · added to claims</div>
        <div style={{display:'flex', flexDirection:'column', gap:4, marginTop:4, fontSize:11.5, color:'rgba(255,255,255,0.65)', fontFamily:'var(--font-mono)'}}>
          <div>D9215 ×6 · +$48</div>
          <div>D1206 ×4 · +$36</div>
          <div>D4910 ×3 · +$312</div>
        </div>
      </div>

      <div className="dash-card">
        <div className="dash-label">New patients · 30d</div>
        <div className="dash-value">22</div>
        <div className="dash-delta up">↑ 4 vs last 30d</div>
        <div style={{fontSize:11, color:'rgba(255,255,255,0.5)', marginTop:4}}>Referrals: 14 · Search: 6 · Other: 2</div>
      </div>

      <div className="dash-card dash-card--wide">
        <div className="dash-label">Practice mix</div>
        <div style={{display:'flex', gap:12, marginTop:6, alignItems:'flex-end'}}>
          {[
            { label:'Hygiene', val:32, color:'#22C0DA' },
            { label:'Perio', val:18, color:'#6BD7E8' },
            { label:'Restorative', val:26, color:'#FBA74A' },
            { label:'Endo', val:8, color:'#F472B6' },
            { label:'Surgery', val:6, color:'#A78BFA' },
            { label:'Other', val:10, color:'#94A3B8' },
          ].map(b => (
            <div key={b.label} style={{flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:6}}>
              <div style={{width:'100%', height: b.val*4 + 'px', background: b.color, borderRadius:6}}></div>
              <div style={{fontSize:11, color:'rgba(255,255,255,0.6)'}}>{b.label}</div>
              <div style={{fontSize:13, fontWeight:600, color:'#fff'}}>{b.val}%</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function mountIfExists(id, el) {
  const node = document.getElementById(id);
  if (node) ReactDOM.createRoot(node).render(el);
}
mountIfExists('sched-mount', <Scheduler />);
mountIfExists('patient-mount', <PatientPage />);
mountIfExists('analytics-mount', <Dashboard />);
